import { render } from "./DialogCanNotRefundAfterDeparture.vue?vue&type=template&id=f48f1214"
import script from "./DialogCanNotRefundAfterDeparture.vue?vue&type=script&lang=js"
export * from "./DialogCanNotRefundAfterDeparture.vue?vue&type=script&lang=js"
script.render = render

export default script